/* eslint-disable */

import { Api as _Api } from '../../common/api/Api';
import { locatePath } from '../../common/RelativeUrl';
export { initCsrfConfig } from '../../common/api/Api';
const Base = new _Api(locatePath('/api/v1'), '');
const AuthBase = new _Api(locatePath('/auth'), '');
export const CurrentUser = Base.appendPath('/users/current');
export const Lessons = Base.appendPath('/lessons');
export const Coaches = Base.appendPath('/coaches');
export const Faqs = Base.appendPath('/faqs_with_categories');
export const PastLessons = Lessons.addParams({
  past: true,
});
export const RecommendedLessons = Base.appendPath('/recommended_lessons');
export const LessonReserve = Lessons.appendPath(':lessonId/reserve');
export const Memberships = Base.appendPath('/memberships');
export const MembershipCurrent = Memberships.appendPath('current');
export const MembershipTickets = Memberships.appendPath('current/tickets');
export const MembershipCurrentCard = Memberships.appendPath('current/card');
export const Reservations = Base.appendPath('/reservations');
export const Reservation = Reservations.appendPath(':reservationId');
export const SignIn = Base.appendPath('/users/sign_in');
export const SignInWithFacebook = {
  post(from: string | string[] | undefined): Promise<Response> {
    let api = AuthBase.appendPath('/facebook');

    if (from) api = api.addParams({ from });

    return api.postAsRaw();
  },
};
export const SignUp = Base.appendPath('/users/new');
export const Api = {
  CurrentUser,
  Lessons,
  Coaches,
  Faqs,
  PastLessons,
  RecommendedLessons,
  LessonReserve,
  SignIn,
  SignInWithFacebook,
  SignUp,
  Memberships,
  MembershipCurrent,
  MembershipTickets,
  MembershipCurrentCard,
  Reservations,
  Reservation,
};
